import { MatDialogRef, MatSnackBar } from '@angular/material';
import { Component, ViewChild } from '@angular/core';
import { UsuarioComponent } from '../../usuario/usuario.component';
import { UsuarioService } from '../../../../providers/usuario.service';

@Component({
    selector: 'crear-usuario-dialog',
    templateUrl: './crear-usuario-dialog.component.html',
    styleUrls: ['./crear-usuario-dialog.component.scss']
})
export class CrearUsuarioDialog {
    error: string = '';
    cargando: boolean = false;

    @ViewChild(UsuarioComponent) // accedemos al formulario de usuario
    private usuarioForm: UsuarioComponent;

    // referencia a si mismo para poder cerrar el dialog...etc.
    constructor(
        public dialogCrear: MatDialogRef<CrearUsuarioDialog>,
        private usurioService: UsuarioService,
        public snackBar: MatSnackBar
    ) { }

    onUsuarioInput() { // si cambian los datos ingresados
        this.error = ''; // limpiamos los mensajes de error del formulario
    }

    onFormState(formState: any): void { // escucha los diferentes estados del formulario
        if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
            this.error = formState.mensaje;
        }

        if (typeof formState.cargando != undefined) {
            this.cargando = formState.cargando;
        }
    }

    onCancelar(): void {
        this.dialogCrear.close();
    }

    onCrear(): void {
        this.error = '';

        this.cargando = true;
        this.usuarioForm.getUsuario()
            .then(
                usuario => {
                    this.usurioService.crearUsuario(usuario).subscribe(
                        respuesta => {
                            if (respuesta.estado == 1) {
                                this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
                                this.dialogCrear.close(respuesta);
                            } else {
                                this.error = respuesta.mensaje;
                            }

                            this.cargando = false;
                        },
                        error => {
                            this.cargando = false;
                            this.error = error;
                        });
                })
            .catch(
                error => {
                    this.error = error;
                    this.cargando = false;
                }
            );
    }
}